import { Component, Inject, OnInit } from '@angular/core'
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { CommonModule } from '@angular/common'
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MasterDatabaseDisplayModel } from '../../master-database-display.model'
import { MatOptionModule } from '@angular/material/core'

@Component({
  selector: 'app-master-add-update-dialog',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    CommonModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
  ],
  templateUrl: './master-add-update-dialog.component.html',
  styleUrls: ['./master-add-update-dialog.component.css'],
})
export class MasterAddUpdateDialogComponent implements OnInit {
  form: FormGroup
  mode: string
  fields: MasterDatabaseDisplayModel[]

  constructor(
    public dialogRef: MatDialogRef<MasterAddUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) {
    this.mode = data.mode
    this.fields = data.fields
    this.form = this.fb.group({})
  }

  ngOnInit(): void {
    this.buildForm()
  }

  buildForm(): void {
    this.fields.forEach((field) => {
      
      const value = this.data.item[field.key] || ''
      let validators: any[] = []
      validators = this.getValidators(field.key)
      this.form.addControl(field.key, new FormControl(value, validators))
    })
  }

  getValidators(key: string): any[] {
    if (key === 'name') {
      return [Validators.required]
    }
    return []
  }

  onSubmit(): void {
    if (this.form.valid) {
      const result = this.form.value
      if (this.mode == 'add') {
        result['addedOn'] = new Date(
          new Date().getTime() - new Date().getTimezoneOffset() * 60000,
        ).toISOString()
      }
      result['modifiedOn'] = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      ).toISOString()
      this.dialogRef.close(result)
    }
  }

  onCancel(): void {
    this.dialogRef.close()
  }
}
